<template>
  <div class="dashboard">
    <div class="dash-content">
      <h1 class="page-title">
        <span>Blog Posts</span
        ><button class="my-btn cw glow wd" @click="startAdd = true">
          Add Post
        </button>
      </h1>

      <div class="my-table">
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>Title</th>
              <th>Author</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in blogs" :key="item.id">
              <td>
                <img
                  v-if="item.image"
                  :src="$upload(item.image)"
                  :alt="item.title"
                />
              </td>
              <td>{{ item.title }}</td>
              <td>{{ item.author }}</td>
              <td>
                <button
                  @click="
                    selectedItem = item;
                    startEdit = true;
                  "
                  class="btn edit"
                >
                  Edit
                </button>
                <button
                  @click="
                    selectedItem = item;
                    startDelete = true;
                  "
                  class="btn delete"
                >
                  Delete
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="pagination">
          <button
            :class="{ disabled: currentPage === 1 }"
            @click="$previousPage()"
          >
            <label>Previous</label>
          </button>
          <p v-if="currentPage > 3">...</p>
          <button class="numbers" v-for="number in pagesNumber" :key="number">
            <label
              :class="{ active: currentPage === number }"
              for=""
              v-if="
                (number == 1 && currentPage <= 2) ||
                (currentPage + 2 >= pagesNumber && number >= pagesNumber - 2) ||
                (number >= currentPage - 2 && number <= currentPage + 2)
              "
              @click="$changePage(number)"
            >
              {{ number }}
            </label>
          </button>
          <p v-if="currentPage <= pagesNumber - 3">...</p>
          <button
            :class="{ disabled: currentPage === pagesNumber.length }"
            @click="$nextPage()"
          >
            <label>Next</label>
          </button>
        </div>
      </div>
      <Model
        v-if="startAdd"
        @closeModel="startAdd = false"
        :modelTitle="'Add Post'"
        :size="'md'"
      >
        <form class="model-body" @submit.prevent="createItem">
          <div class="form-group">
            <label for="name">Title</label>
            <input
              type="text"
              id="name"
              v-model="newItem.title"
              class="form-control"
            />
          </div>
          <div class="form-group">
            <label for="name">Slug</label>
            <input
              type="text"
              id="name"
              v-model="newItem.slug"
              class="form-control"
            />
          </div>
          <div class="form-group">
            <label for="name">Author</label>
            <input
              type="text"
              id="name"
              v-model="newItem.author"
              class="form-control"
            />
          </div>
          <div class="form-group">
            <label for="name">Image</label>
            <o-upload
              :multiple="false"
              @imagesUploaded="
                (data) => {
                  newItem.image = data;
                }
              "
              @imagesUploadedFailed="
                (data) => {
                  console.log('failed');
                }
              "
              :value="newItem.image"
              @startLoader="() => $startLoader()"
              @stopLoader="() => $stopLoader()"
            />
          </div>
          <div class="form-group">
            <label for="name">Content</label>
            <quill-editor
              theme="snow"
              v-model:content="newItem.description"
              :contentType="'html'"
              :placeholder="'Blog Content here...'"
            ></quill-editor>
          </div>
          <div class="btns flex">
            <button
              @click="startAdd = false"
              class="my-btn cw wd cancel"
              type="button"
            >
              Cancel
            </button>
            <button class="btn cw glow wd" type="submit">Add Post</button>
          </div>
        </form>
      </Model>
      <Model
        v-if="startEdit"
        @closeModel="startEdit = false"
        :modelTitle="'Edit Post'"
        :size="'sm'"
      >
        <form class="model-body" @submit.prevent="updateItem">
          <div class="form-group">
            <label for="name">Title</label>
            <input
              type="text"
              id="name"
              v-model="selectedItem.title"
              class="form-control"
            />
          </div>
          <div class="form-group">
            <label for="name">Slug</label>
            <input
              type="text"
              id="name"
              v-model="selectedItem.slug"
              class="form-control"
            />
          </div>
          <div class="form-group">
            <label for="name">Author</label>
            <input
              type="text"
              id="name"
              v-model="selectedItem.author"
              class="form-control"
            />
          </div>
          <div class="form-group">
            <label for="name">Image</label>
            <o-upload
              :multiple="false"
              @imagesUploaded="
                (data) => {
                  selectedItem.image = data;
                }
              "
              @imagesUploadedFailed="
                (data) => {
                  console.log('failed');
                }
              "
              :value="selectedItem.image"
              @startLoader="() => $startLoader()"
              @stopLoader="() => $stopLoader()"
            />
          </div>
          <div class="form-group">
            <label for="name">Content</label>
            <quill-editor
              theme="snow"
              v-model:content="selectedItem.description"
              :contentType="'html'"
              :placeholder="'Blog Content here...'"
            ></quill-editor>
          </div>
          <div class="btns flex">
            <button
              @click="startEdit = false"
              class="my-btn cw wd cancel"
              type="button"
            >
              Cancel
            </button>
            <button class="btn cw wd" type="submit">Update Post</button>
          </div>
        </form>
      </Model>
      <confirmModel
        v-if="startDelete"
        @closeModel="startDelete = false"
        :modelTitle="'Delete Post'"
        :size="'sm'"
        :displayText="'Are you sure you want to delete this Post?'"
        @confirmModel="deleteItem"
      />
    </div>
  </div>
</template>

<script>
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
export default {
  data() {
    return {
      blogs: [],
      newItem: {
        title: "",
        description: "",
        author: "",
      },
      selectedItem: null,
      startAdd: false,
      startEdit: false,
      startDelete: false,
      allItemsCount: 100,
      itemsPerpage: 10,
      pagesNumber: 0,
      currentPage: 1,
    };
  },
  methods: {
    getItems() {
      this.$startLoader();
      this.$store
        .dispatch("GET_BLOGS", {
          token: this.$getAdminToken(),
          data: {
            paginate: 10,
            page: this.currentPage,
          },
        })
        .then((res) => {
          if (res) {
            if (res.status === 200) {
              this.blogs = res.data.blogs.data;
              this.allItemsCount = res.data.blogs.total;
              this.pagesNumber = Math.ceil(
                this.allItemsCount / this.itemsPerpage
              );
              this.$stopLoader();
            } else {
              toast.error(res.data.message);
              this.$stopLoader();
            }
          }
        })
        .catch(() => {
          toast.error("Something went wrong, please try again later.");
          this.$stopLoader();
        });
    },
    createItem() {
      if (this.newItem.title) {
        this.$startLoader();
        this.$store
          .dispatch("CREATE_BLOG", {
            data: this.newItem,
            token: this.$getAdminToken(),
          })
          .then((res) => {
            if (res) {
              if (res.status === 200) {
                toast.success(res.data.message);
                this.getItems();
                this.startAdd = false;
                this.$stopLoader();
                this.newItem = {
                  title: "",
                  description: "",
                  author: "",
                };
              } else {
                toast.error(res.data.message);
                this.$stopLoader();
              }
            }
          })
          .catch(() => {
            toast.error("Something went wrong, please try again later.");
            this.$stopLoader();
          });
      } else {
        toast.error("Please fill all fields");
      }
    },
    updateItem() {
      if (this.selectedItem.title) {
        this.$startLoader();
        this.$store
          .dispatch("UPDATE_BLOG", {
            data: this.selectedItem,
            token: this.$getAdminToken(),
          })
          .then((res) => {
            if (res) {
              if (res.status === 200) {
                toast.success(res.data.message);
                this.getItems();
                this.startEdit = false;
                this.$stopLoader();
                this.selectedItem = null;
              } else {
                toast.error(res.data.message);
                this.$stopLoader();
              }
            }
          })
          .catch(() => {
            toast.error("Something went wrong, please try again later.");
            this.$stopLoader();
          });
      } else {
        toast.error("Please fill all fields");
      }
    },
    deleteItem() {
      this.$startLoader();
      this.$store
        .dispatch("DELETE_BLOG", {
          data: this.selectedItem,
          token: this.$getAdminToken(),
        })
        .then((res) => {
          if (res) {
            if (res.status === 200) {
              toast.success(res.data.message);
              this.getItems();
              this.startDelete = false;
              this.$stopLoader();
            } else {
              toast.error(res.data.message);
              this.$stopLoader();
            }
          }
        })
        .catch(() => {
          toast.error("Something went wrong, please try again later.");
          this.$stopLoader();
        });
    },
  },
  mounted() {
    this.getItems();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/main.scss";
.dashboard {
  padding-bottom: 5rem;
  .page-title {
    margin: 20px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    span {
      font-size: 1.5rem;
      font-weight: 600;
    }
    button {
      padding: 0.5rem 1rem;
      background-color: $primary_color;
      color: white;
      border: none;
      border-radius: 5px;
      cursor: pointer;
      transition: all 0.3s ease-in-out;
      font-size: 1rem;
      &:hover {
        background-color: $secondary_color;
      }
    }
  }
  .dash-content {
    padding: 0 2rem;
    .my-table {
      table {
        width: 100%;
        border-collapse: collapse;
        thead {
          th {
            text-align: left;
            padding: 1rem 0;
            font-weight: 600;
            border-bottom: 1px solid #e5e8ee;
          }
        }
        tbody {
          tr {
            td {
              padding: 5px;
              border-bottom: 1px solid #e5e8ee;
              img {
                width: 100px;
                height: 50px;
                object-fit: cover;
                border-radius: 5px;
              }
              button {
                margin-right: 10px;
                color: #fff;
                &.edit {
                  background-color: #1d2088;
                  color: white;
                  &:hover {
                    background-color: #1eb9ee;
                  }
                }
                &.delete {
                  background-color: #a82929;
                  color: white;
                  &:hover {
                    background-color: #7a1f1f;
                  }
                }
                &.default {
                  background-color: #1d2088;
                  color: white;
                  &:hover {
                    background-color: #1eb9ee;
                  }
                }
              }
            }
          }
        }
      }
    }
    .btns {
      margin-top: 1rem;
      display: flex;
      justify-content: space-between;
      button {
        margin-right: 10px;
        padding: 0.35rem 0.5rem;
        color: #fff;
        &.cancel {
          background-color: #a82929;
          color: white;
          &:hover {
            background-color: #7a1f1f;
          }
        }
      }
    }
  }
}
</style>